import { Button, Stack, useTheme } from "@mui/material";
import React from "react";
import { HiOutlineMinusSm, HiOutlinePlusSm } from "react-icons/hi";

interface CounterButtonProps {
  children: React.ReactNode;
  onClick?: (a: any) => void;
  isDisabled?: boolean;
}

function CounterButton({ children, onClick, isDisabled }: CounterButtonProps) {
  const { palette } = useTheme();

  return (
    <Button
      variant="contained"
      disabled={isDisabled}
      sx={{
        fontSize: "1.2rem",
        // backgroundColor: palette.grey[600],
        borderRadius: 0,
        width: "48px",
        minWidth: "unset",
        padding: "12px",
        // "&:hover": { backgroundColor: palette.grey[800] },
      }}
      onClick={(e) => onClick && onClick(e)}
    >
      {children}
    </Button>
  );
}

interface CounterProps {
  value: number;
  step?: number;
  onChange: (value: number) => void;
  isDisabledPlus?: boolean;
  isDisabledMinus?: boolean;
}

export function Counter({
  step = 1,
  value,
  onChange,
  isDisabledPlus,
  isDisabledMinus,
}: CounterProps) {
  const { palette } = useTheme();

  const handleChange = (increment: boolean) => {
    onChange(increment ? value + step : value - step);
  };

  return (
    <Stack
      direction={"row"}
      borderRadius={"6px"}
      overflow={"hidden"}
      height={"100%"}
    >
      <CounterButton
        onClick={() => handleChange(false)}
        isDisabled={isDisabledMinus}
      >
        <HiOutlineMinusSm />
      </CounterButton>
      <Stack
        flexGrow={1}
        border={`1px solid ${palette.divider}`}
        // borderLeft={`2px solid ${palette.grey[500]}`}
        // borderRight={`2px solid ${palette.grey[500]}`}
        textAlign={"center"}
        fontSize={"1.2rem"}
        justifyContent={"center"}
        alignItems={"center"}
        // fontFamily={"Inter"}
        // color={palette.grey[400]}
      >
        {value}
      </Stack>
      <CounterButton
        onClick={() => handleChange(true)}
        isDisabled={isDisabledPlus}
      >
        <HiOutlinePlusSm />
      </CounterButton>
    </Stack>
  );
}
